import { render, staticRenderFns } from "./FaqiRefund.vue?vue&type=template&id=2fc3cc48&scoped=true&"
import script from "./FaqiRefund.vue?vue&type=script&lang=js&"
export * from "./FaqiRefund.vue?vue&type=script&lang=js&"
import style0 from "./FaqiRefund.vue?vue&type=style&index=0&id=2fc3cc48&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3cc48",
  null
  
)

export default component.exports